require('videogular');
require('./vg-controls');

module.exports = 'com.2fdevs.videogular.plugins.controls';



//////////////////
// WEBPACK FOOTER
// ./~/videogular-controls/index.js
// module id = ./node_modules/videogular-controls/index.js
// module chunks = 1